import type { Dayjs } from 'dayjs';
import d from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

d.extend(customParseFormat);
d.extend(timezone);
d.extend(utc);

export type dayjs = Dayjs;
export const dayjs = d;
